"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const classFunctions_1 = require("../../../utils/classFunctions");
const TableCell = (props) => {
    var _a;
    const { rowIndex, rowCount, cell, selectionProps, tableRef, tableModificators, } = props;
    tableRef.current.useCellMount(rowIndex, cell.column.id);
    const cellClassNames = (0, classFunctions_1.getClasses)(`${__1.className}__cell`, (_a = tableModificators === null || tableModificators === void 0 ? void 0 : tableModificators.column) === null || _a === void 0 ? void 0 : _a.call(tableModificators, cell.column));
    const column = cell.column;
    if (column.cellClasses)
        cellClassNames.push(...column.cellClasses);
    return (react_1.default.createElement("td", { ...cell.getCellProps([
            { style: column.style },
        ]), className: cellClassNames.join(' ') }, cell.render('Cell', {
        ...selectionProps,
        tableRef,
        rowIndex,
        rowCount,
    })));
};
exports.TableCell = TableCell;
//# sourceMappingURL=cell.js.map